

















import { defineComponent, Ref, ref, toRefs } from '@nuxtjs/composition-api'
import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { useDynamicForm } from '~/compositions/dynamic-form'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import CMakeLogo from '~/components/shared/configurable/make/CMakeLogo.vue'
import { CategoryId } from '~/models/category/types'

export default defineComponent({
  components: { CMakeLogo, CFormError },
  props: DYNAMIC_FORM_FIELD_PROPS,
  setup(props) {
    const { name, fieldValues } = toRefs(props)
    const selectedOption = ref<number>(
      fieldValues.value.servicing_category ||
        fieldValues.value.category ||
        CategoryId.CARS
    )
    const { value, error, changeValue } = useDynamicForm(props, {
      onValue: (v: Ref<number>) => {
        if (v.value) {
          selectedOption.value = v.value
        }
      }
    })

    function handleSelection(val: any) {
      changeValue(name.value, val)
    }

    return {
      value,
      error,
      handleSelection,
      selectedOption
    }
  }
})
